import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";

function shortFopNameFromCanonical(canonicalName) {
    if (!canonicalName?.trim()) return "";
    const s = canonicalName.trim();
    if (!s.toLowerCase().startsWith("фоп")) return s;
    const parts = s.split(/\s+/).filter(Boolean);
    if (parts[1] === "Нежид" && parts[2] === "Ірина") return "ФОП Ірина";
    return parts.length >= 2 ? `ФОП ${parts[1]}` : s;
}

function findFopOption(options, storedFop) {
    const t = (storedFop || "").trim();
    if (!t || !Array.isArray(options)) return null;
    return (
        options.find((f) => f.key === t) ||
        options.find((f) => f.label === t) ||
        options.find((f) => (f.displayLabel || "").trim() === t) ||
        options.find((f) => shortFopNameFromCanonical(f.label) === t) ||
        null
    );
}

const NovaPayPaymentModal = ({ show, onHide, returnData, onSuccess, fopOptions: fopOptionsProp }) => {
    const [fopKey, setFopKey] = useState(null);
    const [status, setStatus] = useState("idle");
    const [fetchedOptions, setFetchedOptions] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");

    // Если prop передан — используем сразу, без async; иначе грузим сами
    const fopOptions = fopOptionsProp?.length ? fopOptionsProp : fetchedOptions;

    useEffect(() => {
        if (!show) return;
        setStatus("idle");
        setErrorMessage("");
        if (fopOptionsProp?.length) return;
        fetch("/api/users/novapay-fop-options", { credentials: "include" })
            .then((r) => (r.ok ? r.json() : []))
            .then((data) => setFetchedOptions(Array.isArray(data) ? data : []))
            .catch(() => setFetchedOptions([]));
    }, [show, fopOptionsProp]);

    useEffect(() => {
        if (!fopOptions.length) return;
        const match = findFopOption(fopOptions, returnData?.fop);
        setFopKey(match?.key || "");
    }, [returnData, fopOptions]);

    const handleSubmit = async () => {
        setStatus("loading");
        setErrorMessage("");
        try {
            const res = await fetch("/api/novapay/payment", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                    fopKey,
                    returnId: returnData._id,
                    amount: String(returnData.refundAmount || "").replace(" грн", "").trim(),
                    iban: String(returnData.iban || "").replaceAll(" ", ""),
                    name: returnData.cardOwner,
                    taxId: returnData.cardOwnerTaxId,
                    purpose: `Повернення коштів, не підлягає оподаткуванню`,
                }),
            });
            const data = await res.json().catch(() => ({}));
            if (res.ok && data.success) {
                setStatus("success");
                onSuccess(returnData._id);
                setTimeout(onHide, 1500);
            } else {
                console.error("NovaPay payment response:", res.status, data);
                setStatus("error");
                setErrorMessage(
                    data?.error ||
                        `Помилка ${res.status}: не вдалося створити платіж`
                );
            }
        } catch (e) {
            console.error(e);
            setStatus("error");
            setErrorMessage(e?.message || "Помилка мережі");
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Платіж через NovaPay</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>ФОП</Form.Label>
                    <Form.Select
                        value={fopKey || ""}
                        onChange={(e) => setFopKey(e.target.value)}
                    >
                        <option value="">Оберіть ФОП</option>
                        {fopOptions.map((f) => (
                            <option key={f.key} value={f.key}>
                                {f.displayLabel || f.label}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Сума</Form.Label>
                    <Form.Control value={returnData.refundAmount.replace(" грн", "")} disabled />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>IBAN</Form.Label>
                    <Form.Control value={returnData.iban.replaceAll(" ", "")} disabled />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>ІПН</Form.Label>
                    <Form.Control value={returnData.cardOwnerTaxId} disabled />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>ПІБ отримувача</Form.Label>
                    <Form.Control value={returnData.cardOwner} disabled />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Призначення платежу</Form.Label>
                    <Form.Control value={`Повернення коштів, не підлягає оподаткуванню`} disabled />
                </Form.Group>
                {status === "error" && errorMessage && (
                    <Alert variant="danger" className="mb-0">
                        {errorMessage}
                    </Alert>
                )}
                {status === "success" && (
                    <Alert variant="success" className="mb-0">
                        Платіж створено ✅
                    </Alert>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Скасувати
                </Button>
                <Button
                    variant={status === "error" ? "danger" : "success"}
                    onClick={handleSubmit}
                    disabled={status === "loading" || status === "success" || !fopKey}
                >
                    {status === "loading" ? <Spinner size="sm" animation="border" /> : "Сплатити"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default NovaPayPaymentModal;
